import React from "react";
import axios from "axios";
import { ArrowRight, Loader2 } from "lucide-react";
import { API, StatusPill, LineupPill, na, pct } from "@/components/fbShared";

export const FirstBucketHomeTile = ({ onGo }) => {
  const [d, setD] = React.useState(null);
  React.useEffect(() => { axios.get(`${API}/slate`).then((r) => setD(r.data)).catch(() => setD({ error: true })); }, []);
  const rows = (d?.most_likely || []).slice(0, 6);
  return (
    <section className="rounded-xl border border-orange-900/50 bg-[#0B0F17] p-4 lg:col-span-2" data-testid="home-nba">
      <div className="mb-3 flex items-center justify-between">
        <p className="font-display text-sm font-bold uppercase tracking-wide text-slate-100">🏀 First Bucket · tonight's first-basket candidates</p>
        <button type="button" onClick={() => onGo("nba")} data-testid="home-nba-link" className="flex min-h-[36px] items-center gap-1 rounded-lg px-2 font-mono text-[11px] font-bold uppercase text-orange-300 transition-colors hover:bg-orange-950/40">
          Open First Bucket <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </div>
      {!d ? <div className="flex items-center gap-2 py-4 font-mono text-[11px] text-slate-500"><Loader2 className="h-4 w-4 animate-spin text-orange-400" /> Loading NBA slate…</div>
        : d.error ? <p className="py-4 text-center font-mono text-[11px] text-rose-400">NBA slate unavailable.</p>
        : !rows.length ? <p className="py-4 text-center font-mono text-[11px] text-slate-600" data-testid="home-nba-empty">No NBA games today.</p> : (
          <>
            <p className="mb-2 font-mono text-[10px] text-slate-500">{d.summary.games} games · {d.summary.approved} approved · mode {d.mode} · {d.calibrated ? "calibrated estimates" : "model ranking — not calibrated"}</p>
            <div className="grid gap-1.5 md:grid-cols-2">
              {rows.map((c) => (
                <button key={`${c.game_id}-${c.id}`} type="button" onClick={() => onGo("nba")} data-testid={`home-nba-row-${c.id}`}
                  className="flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2 text-left transition-colors hover:border-orange-700/60">
                  <StatusPill s={c.status} />
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-[12px] font-bold text-orange-100">{c.name} · {c.team} {c.pos || ""}</span>
                    <span className="block truncate font-mono text-[9px] text-slate-500">vs {c.opp} · fusion {na(c.fusion)} · {d.calibrated ? pct(c.prob) : "uncal."}</span>
                  </span>
                  <LineupPill s={c.starter} />
                </button>
              ))}
            </div>
          </>
        )}
    </section>
  );
};

export default FirstBucketHomeTile;
